import store from "@/store";
import { publish } from '@/utils/lanMqtt'
import Vue from "vue";
const vm = Vue.prototype;


async function publish_data(subffix, data) {
  const { modeId, deviceId, uuid } = store.getters.GET_LAN_MQTT || {}
  return await publish(uuid,
    `anycubic/anycubicCloud/v1/web/printer/${modeId}/${deviceId}/${subffix}`,
    data
  )
}
async function publish_object(subffix, obj) {
  return await publish_data(subffix, obj)
}
//  设备外设状态上报(插入或者拔出均上报)
function mqtt_peripherie() {

  return publish_data(`peripherie`,
    {
      type: "peripherie",
      action: "query",
      timestamp: new Date().getTime(),
      msgid: `${vm.$uuid.v1()}`,
      data: null
    }
  )
}

//  轴移动
function mqtt_move(axis, move_type, distance) {
  return publish_data(`axis`,
    {
      type: "axis",
      action: "move",
      timestamp: new Date().getTime(),
      msgid: `${vm.$uuid.v1()}`,
      data: {
        axis,
        move_type,
        distance
      }
    }
  )
}

//  关闭电机
export function mqtt_turnOff() {
  return publish_data(`axis`,
    {
      type: "axis",
      action: "turnOff",
      timestamp: new Date().getTime(),
      msgid: `${vm.$uuid.v1()}`,
      data: null
    }
  )
}

//  自动续料
function mqtt_setAutoFeed(id, autoFeed) {
  return publish_data(`multiColorBox`,
    {
      type: "multiColorBox",
      action: "setAutoFeed",
      timestamp: new Date().getTime(),
      msgid: `${vm.$uuid.v1()}`,
      data: {
        multi_color_box: [
          {
            id,
            auto_feed: autoFeed ? 1 : 0
          }
        ]
      }
    }
  )
}

//  开启/关闭烘干
function mqtt_setDry(id, status, target_temp, duration) {

  let params = null
  if (status === 1) {
    params =
    {
      status: 1,
      target_temp,
      duration
    }
  } else {
    params =
    {
      status: 0
    }
  }
  return publish_data(`multiColorBox`,
    {
      type: "multiColorBox",
      action: "setDry",
      timestamp: new Date().getTime(),
      msgid: `${vm.$uuid.v1()}`,
      data: {
        multi_color_box: [
          {
            id,
            drying_status: params
          }
        ]
      }
    }
  )
}

//  设置单个料槽信息
function mqtt_setInfo(id, index, type, color) {
  return publish_data(`multiColorBox`,
    {
      type: "multiColorBox",
      action: "setInfo",
      timestamp: new Date().getTime(),
      msgid: `${vm.$uuid.v1()}`,
      data: {
        multi_color_box: [
          {
            id,
            slots: [
              {
                index,
                type,
                color
              }
            ]
          }
        ]
      }
    }
  )
}

//  多色盒子进料操作
function mqtt_feedFilament(id, slot_index, type) {
  return publish_data(`multiColorBox`,
    {
      type: "multiColorBox",
      action: "feedFilament",
      timestamp: new Date().getTime(),
      msgid: `${vm.$uuid.v1()}`,
      data: {
        multi_color_box: [
          {
            id,
            feed_status: {
              slot_index,
              type,
            }
          }
        ]
      }
    }
  )
}

//  多色盒子设置料槽颜色
function mqtt_setExtfilbox(type, color) {
  return publish_data(`extfilbox`,
    {
      type: "extfilbox",
      action: "setInfo",
      timestamp: new Date().getTime(),
      msgid: `${vm.$uuid.v1()}`,
      data: {
        type,
        color
      }
    }
  )
}

//  获取多色盒子基本信息
function mqtt_getInfoMultiColorBox() {
  return publish_data(`multiColorBox`,
    {
      type: "multiColorBox",
      action: "getInfo",
      timestamp: new Date().getTime(),
      msgid: `${vm.$uuid.v1()}`,
      data: null
    }
  )
}

//    获取外置料架基本信息
function mqtt_getInfoExtfilbox() {
  return publish_data(`extfilbox`,
    {
      type: "extfilbox",
      action: "getInfo",
      timestamp: new Date().getTime(),
      msgid: `${vm.$uuid.v1()}`,
      data: null
    }
  )
}

//  外置料架进退料
function mqtt_replaceFilament(index) {
  return publish_data(`filament`,
    {
      type: "filament",
      action: "replace",
      timestamp: new Date().getTime(),
      msgid: `${vm.$uuid.v1()}`,
      data: {
        type: index
      }
    }
  )
}

//  摄像机开始推流/结束推流
export function mqtt_videoCapture(action) {
  return publish_data(`video`,
    {
      type: "video",
      action,
      timestamp: new Date().getTime(),
      msgid: `${vm.$uuid.v1()}`,
      data: null
    }
  )
}

//  灯光查询
function mqtt_light() {
  return publish_data(`light`,
    {
      type: "light",
      action: "query",
      timestamp: new Date().getTime(),
      msgid: `${vm.$uuid.v1()}`,
      data: null
    }
  )
}

//  零件查询
function mqtt_skip_start(arr) {
  return publish_data('skip', {
    type: "skip",
    action: "start",
    timestamp: new Date().getTime(),
    msgid: `${vm.$uuid.v1()}`,
    data: {
      objects_skip_parts: [...arr]
    }
  })
}

//  零件跳过
function mqtt_query_obj() {
  return publish_data('skip',
    {
      type: "skip",
      action: "query_obj",
      timestamp: new Date().getTime(),
      msgid: `${vm.$uuid.v1()}`,
      data: null
    }
  )
}

//  获取当前打印模型信息
function mqtt_file_details(filename) {
  return publish_data('file',
    {
      type: "file",
      action: "fileDetails",
      timestamp: new Date().getTime(),
      msgid: `${vm.$uuid.v1()}`,
      data: {
        root: "local",
        filename
      }
    }
  )
}

const mqtt_fuction = {
  mqtt_getInfoExtfilbox,
  mqtt_getInfoMultiColorBox,
  mqtt_peripherie,
  mqtt_setExtfilbox,
  mqtt_setInfo,
  mqtt_feedFilament,
  mqtt_replaceFilament,
  mqtt_setDry,
  mqtt_setAutoFeed,
  mqtt_turnOff,
  mqtt_move,
  mqtt_videoCapture,
  mqtt_light,
  mqtt_query_obj,
  mqtt_skip_start,
  mqtt_file_details
}

export default mqtt_fuction 